import { FormEvent } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Container, DialogContent, IconButton } from '@mui/material';

import type { SavedFilter } from '@/types';

import clientRequestStyles from '../PropertyRequests/RequestsMyListItem/RequestsMyListItem.module.scss';
import { MyButton } from '../uiComponents/MyButton';
import { StyledDialog, StyleDialogTitle } from '../uiComponents/styled';

interface DeleteSavedFilterDialogProps {
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  savedFilter: SavedFilter | null;
}

export const DeleteSavedFilterDialog = ({
  isSubmitting,
  onClose,
  onConfirm,
  open,
  savedFilter,
}: DeleteSavedFilterDialogProps) => {
  const handleClose = () => {
    if (isSubmitting) return;

    onClose();
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!savedFilter || isSubmitting) return;

    onConfirm();
  };

  return (
    <StyledDialog
      aria-busy={isSubmitting}
      aria-describedby='delete-saved-filter-dialog-description'
      aria-labelledby='delete-saved-filter-dialog-title'
      disableEscapeKeyDown={isSubmitting}
      onClose={handleClose}
      open={open}
      width='730'
    >
      <Container component='main' style={{ width: '100%' }}>
        <StyleDialogTitle
          id='delete-saved-filter-dialog-title'
          sx={{ m: 0, color: '#2A3842', textAlign: 'center' }}
        >
          CONFIRM DELETION OF SAVED FILTER
          <IconButton
            aria-label='Close'
            autoFocus
            disabled={isSubmitting}
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </StyleDialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <div
              className={clientRequestStyles.dialogDescription}
              id='delete-saved-filter-dialog-description'
              style={{ overflowWrap: 'anywhere' }}
            >
              Are you sure you want to delete <strong>{savedFilter?.name}</strong>? This action
              cannot be undone.
            </div>
            <div className={clientRequestStyles.dialogButtons}>
              <MyButton
                data={{
                  buttonName: isSubmitting ? 'Deleting...' : 'Delete',
                  buttonType: 'submit',
                  customWidth: '226px',
                  variant: 'contained',
                }}
                disabled={!savedFilter || isSubmitting}
              />
              <MyButton
                data={{
                  buttonName: 'Cancel',
                  buttonType: 'button',
                  customWidth: '226px',
                  styleType: 'cancel',
                  variant: 'outlined',
                }}
                disabled={isSubmitting}
                onClick={handleClose}
              />
            </div>
          </form>
        </DialogContent>
      </Container>
    </StyledDialog>
  );
};
